import { gql } from '@apollo/client';

export const CREATE_TRANSITION = gql`
  mutation CreateTransition($input: CreateTransitionInput!) {
    createTransition(input: $input) {
      id
      name
      videoKey
      videoURL
      type
      isActive
    }
  }
`;

export const UPDATE_TRANSITION = gql`
  mutation UpdateTransition($id: String!, $input: UpdateTransitionInput!) {
    updateTransition(id: $id, input: $input) {
      id
      name
      videoKey
      videoURL
      type
      isActive
    }
  }
`;

export const DELETE_TRANSITION = gql`
  mutation DeleteTransition($id: String!) {
    deleteTransition(id: $id)
  }
`;

export const INIT_TRANSITION_MULTIPART_UPLOAD = gql`
  mutation InitTransitionMultipartUpload(
    $input: InitTransitionMultipartUploadInput!
  ) {
    initTransitionMultipartUpload(input: $input) {
      fileId
      fileKey
      signedUrls {
        partNumber
        signedUrl
      }
    }
  }
`;

export const COMPLETE_TRANSITION_MULTIPART_UPLOAD = gql`
  mutation CompleteTransitionMultipartUpload(
    $input: CompleteMultipartUploadInput!
  ) {
    completeTransitionMultipartUpload(input: $input)
  }
`;
